function readURL(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function(e) {
            var image_upload_wrap = $(input).parent();
            image_upload_wrap.hide();
            var file_upload_content = $(image_upload_wrap).next('.file-upload-content');
            var file_upload_image = $(file_upload_content).find('.file-upload-image');
            var image_title_wrap = $(file_upload_content).find('.image-title-wrap');
            if (input.files[0].type == 'application/pdf') {
                $(file_upload_image).attr('src', './src/file-upload-input/pdf-doc.png');
            } else {
                $(file_upload_image).attr('src', e.target.result);
            }
            $(file_upload_content).removeClass('d-none');
            $(file_upload_content).show();
            $(file_upload_content).css('display', 'flex');
            $(file_upload_content).css('align-items', 'center');
            $('.image-title').html(input.files[0].name);
            /*
                            var image = new Image();
                            image.src =  e.target.result;
                            image.onload = function(){

                                img_c = $('.file-upload-content').width();
                                img_i = this.naturalWidth;
                                
                                alert(img_i);
                            }
            */



        };

        if ($(input).attr('maxsize')) {
            var maxsize = $(input).attr('maxsize');

            if (parseInt(input.files[0].size / 1034) > parseInt(maxsize)) { // kb
                alert('O ficheiro não poder ter mais de ' + maxsize + ' KB');
            } else {
                reader.readAsDataURL(input.files[0]);
            }
        } else {
            reader.readAsDataURL(input.files[0]);
        }

        /*
            $('.file-upload-image').css('margin-left', '100%');
            $('.file-upload-image').css('margin-right', '100%');
            */

    } else {
        removeUpload();
    }
}

function removeUpload(file_upload_input) {
    var image_upload_wrap = $(file_upload_input).parent();
    var input_image_existente = $(image_upload_wrap).prev('input:hidden');
    var file_upload_content = $(image_upload_wrap).next('.file-upload-content');
    var file_upload_image = $(file_upload_content).find('.file-upload-image');

    //$(file_upload_input).replaceWith($(file_upload_input).clone()); // retirado - está em análise
    $(file_upload_input).val(''); // está em análise
    $(input_image_existente).val('');
    $(file_upload_content).css('display', 'none');
    $(file_upload_content).removeClass('d-block');
    $(file_upload_content).hide();
    $(image_upload_wrap).removeClass('d-none');
    $(image_upload_wrap).show();
    $(file_upload_image).attr('src', '#');

    /*
     $('.file-upload-input').replaceWith($('.file-upload-input').clone());
     $('.file-upload-content').css('display', 'none');
     $('.file-upload-content').hide();
     $('.image-upload-wrap').show();
     */
}
$('.image-upload-wrap').bind('dragover', function() {
    $('.image-upload-wrap').addClass('image-dropping');
});
$('.image-upload-wrap').bind('dragleave', function() {
    $('.image-upload-wrap').removeClass('image-dropping');
});

export { readURL, removeUpload };